import React, { useState } from 'react';
import { Input, Radio, List, Card, Tag, Empty, Pagination, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useSearchStore } from '../stores/searchStore';

const { Search } = Input;

const SearchPage = () => {
  const navigate = useNavigate();
  const { searchResults, isLoading, pagination, search, semanticSearch, searchHistory } = useSearchStore();
  
  const [searchQuery, setSearchQuery] = useState('');
  const [searchType, setSearchType] = useState('text');
  
  const handleSearch = (value) => {
    if (!value.trim()) return;
    
    setSearchQuery(value);
    if (searchType === 'text') {
      search(value);
    } else {
      semanticSearch(value);
    }
  };
  
  const handleSearchTypeChange = (e) => {
    setSearchType(e.target.value);
    if (searchQuery) {
      if (e.target.value === 'text') {
        search(searchQuery);
      } else {
        semanticSearch(searchQuery);
      }
    }
  };
  
  const handlePageChange = (page, pageSize) => {
    if (searchType === 'text') {
      search(searchQuery, page, pageSize);
    } else {
      semanticSearch(searchQuery, page, pageSize);
    }
  };
  
  return (
    <div>
      <h2>Search Notes</h2>
      
      <div style={{ marginBottom: 16 }}>
        <Search
          placeholder="Enter search keywords"
          enterButton="Search"
          size="large"
          onSearch={handleSearch}
          style={{ width: '100%', marginBottom: 16 }}
        />
        
        <Radio.Group onChange={handleSearchTypeChange} value={searchType}>
          <Radio value="text">Text Search</Radio>
          <Radio value="semantic">Semantic Search</Radio>
        </Radio.Group>
        
        {searchHistory.length > 0 && (
          <div style={{ marginTop: 8 }}>
            <small>Recent searches: </small>
            {searchHistory.map((term, index) => (
              <Tag
                key={index}
                style={{ cursor: 'pointer' }}
                onClick={() => handleSearch(term)}
              >
                {term}
              </Tag>
            ))}
          </div>
        )}
      </div>
      
      <Spin spinning={isLoading}>
        {searchResults.length > 0 ? (
          <div>
            <List
              dataSource={searchResults}
              renderItem={item => (
                <List.Item
                  key={item.id}
                  onClick={() => navigate(`/notes/${item.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <Card
                    title={item.title}
                    style={{ width: '100%' }}
                    extra={
                      <span>
                        {item.similarity && `Similarity: ${(item.similarity * 100).toFixed(2)}%`}
                      </span>
                    }
                  >
                    <p>{item.summary || item.content.substring(0, 200)}</p>
                    <div>
                      {item.tags?.map(tag => (
                        <Tag key={tag.id} color={tag.color}>
                          {tag.name}
                        </Tag>
                      ))}
                    </div>
                  </Card>
                </List.Item>
              )}
            />
            
            <div style={{ marginTop: 16, textAlign: 'right' }}>
              <Pagination
                current={pagination.page}
                pageSize={pagination.limit}
                total={pagination.total}
                onChange={handlePageChange}
                showSizeChanger
                showQuickJumper
                showTotal={(total) => `${total} results total`}
              />
            </div>
          </div>
        ) : (
          searchQuery && !isLoading && (
            <Empty description="No matching notes found" />
          )
        )}
      </Spin>
    </div>
  );
};

export default SearchPage;
